import { Route } from 'react-router';
import { getOutboundWireDetailsPath } from '../path/path';
import { OutboundWireDetailsPage } from '../OutboundWireDetailsPage';

export const OutboundWireRoutes = [
  <Route
    key={getOutboundWireDetailsPath()}
    path={getOutboundWireDetailsPath()}
    element={<OutboundWireDetailsPage />}
  />,
];
